import BaseModel from './BaseModel';

export default class TrainingStats extends BaseModel {
  constructor(data = {}) {
    super(TrainingStats, data);
    this.requiredRelevantVotesRemainingCount =
      data.requiredRelevantVotesRemainingCount;
    this.requiredNotRelevantVotesRemainingCount =
      data.requiredNotRelevantVotesRemainingCount;
    this.votesUntilTriggerTrainingCount =
      data.votesUntilTriggerTrainingCount;
  }

  datasetInvalid() {
    return (
      this.requiredRelevantVotesRemainingCount > 0 ||
      this.requiredNotRelevantVotesRemainingCount > 0
    );
  }
}
